import { render } from "./AllAppointmentHours.vue?vue&type=template&id=5c0ce20c&scoped=true"
import script from "./AllAppointmentHours.vue?vue&type=script&lang=js"
export * from "./AllAppointmentHours.vue?vue&type=script&lang=js"

import "./AllAppointmentHours.vue?vue&type=style&index=0&id=5c0ce20c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0ce20c"]])

export default __exports__